import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetRegisteredPlayer from '@/modules/manage-player/api/hooks/useQueryGetRegisteredPlayer'
import RegisteredPlayerListing from '@/modules/manage-player/components/RegisteredPlayer/components/RegisteredPlayerListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { useQueryState, parseAsString, parseAsBoolean } from 'nuqs'
import { useEffect, useState } from 'react'
import { format, startOfDay, endOfDay } from 'date-fns'

type SortOrder = 'asc' | 'desc' | undefined

function RegisteredPlayerPage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const [sortField, setSortField] = useState<
		'createdAt' | 'totalDepositAmount'
	>()
	const [sortOrder, setSortOrder] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'createdAt' || columnId === 'totalDepositAmount') {
			setSortField(columnId)
			setSortOrder(order)
		}
	}
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)
	const [hasDeposit] = useQueryState(
		'hasDeposit',
		parseAsBoolean.withDefault(false),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		hasDeposit: hasDeposit || undefined,
		...(sortField === 'createdAt' &&
			sortOrder && {
				orderByCreatedAt: sortOrder,
			}),
		...(sortField === 'totalDepositAmount' &&
			sortOrder && {
				orderByTotalDepositAmount: sortOrder,
			}),
	}

	const { data, isLoading } = useQueryGetRegisteredPlayer(payload)

	return (
		<PageContainer>
			<RegisteredPlayerListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedRegisteredPlayerPage = withUserPermission(RegisteredPlayerPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedRegisteredPlayerPage
